import type { ReactNode } from 'react';

import styles from './PageHeader.module.css';

export interface PageHeaderProps {
  title: ReactNode;
  lede?: ReactNode;
  /** Above the title, e.g. a link back; routing is the caller's. */
  back?: ReactNode;
  /** Beside the title, e.g. a status chip. */
  badges?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ title, lede, back, badges, actions }: PageHeaderProps) {
  return (
    <div className={styles.header}>
      {back ? <div className={styles.back}>{back}</div> : null}
      <div className={styles.row}>
        <div className={styles.text}>
          <h1 className={styles.title}>
            {title}
            {badges ? <span className={styles.badges}>{badges}</span> : null}
          </h1>
          {lede ? <p className={styles.lede}>{lede}</p> : null}
        </div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
    </div>
  );
}
